import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FormularioProdutor from '../../../components/auth/Formularios/FormularioProdutor';
import useAuth from '../../../hooks/useAuth';

function Step3Cadastro({ onSuccess }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const initialEmail = user?.email || '';

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5" gutterBottom textAlign="center">
        {t('wizard.step3.title')}
      </Typography>
      <Typography variant="body2" mb={4} textAlign="center">
        {t('wizard.step3.subtitle')}
      </Typography>

      <FormularioProdutor onSuccess={onSuccess} wizardMode initialEmail={initialEmail} />
    </Box>
  );
}

export default Step3Cadastro;
